import { render, staticRenderFns } from "./TikTokVideos.vue?vue&type=template&id=3d8e1765&scoped=true&lang=pug&"
import script from "./TikTokVideos.vue?vue&type=script&lang=js&"
export * from "./TikTokVideos.vue?vue&type=script&lang=js&"
import style0 from "./TikTokVideos.vue?vue&type=style&index=0&id=3d8e1765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e1765",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d8e1765')) {
      api.createRecord('3d8e1765', component.options)
    } else {
      api.reload('3d8e1765', component.options)
    }
    module.hot.accept("./TikTokVideos.vue?vue&type=template&id=3d8e1765&scoped=true&lang=pug&", function () {
      api.rerender('3d8e1765', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/components/TikTokVideos.vue"
export default component.exports